import { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import EditableText from '../../Form/EditableText';
import CloseButton from '../../Buttons/Close';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import { ImagesContext } from '../../../contexts/ImagesContext';
import BlockTextWithBackgroundData from './BlockTextWithBackgroundData';
import ImageModal from '../../Modals/ImageModal/ImageModal';
import { useGetBase64Image } from '../../../hooks/UseGetBase64Image';
import { BlockHeight } from '../../../models/BlockSettings';

function BlockTextWithBackground({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockTextWithBackgroundData);

  const [minHeight, setMinHeight] = useState('');
  const [maxHeight, setMaxHeight] = useState('');

  useEffect(() => {
    if (props.height === BlockHeight.TALL) {
      setMinHeight('600px');
      setMaxHeight(null);
    } else {
      setMinHeight(null);
      setMaxHeight(null);
    }
  }, [props]);

  const handleUpdate = (text?: string) => {
    props.title.value = text;
    editHandler(data.id, { ...props });
  };

  const { images } = useContext(ImagesContext);
  const base64Image = useGetBase64Image(props.url.value);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: `${minHeight}`,
        maxHeight: `${maxHeight}`,
        overflow: 'hidden',
        backgroundImage: `url(${base64Image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >

      {(isEditing && !isTemplate) && (
        <ImageModal
          showTitle={false}
          images={images}
          handleOnConfirm={(url: string) => {
            props.url.value = url;
            editHandler(data.id, props);
          }}
        />
      )}

      {props.title && (
        <Grid
          item
          sx={Utils.hoverBorder(isEditing, { my: 8, mx: 2 })}
        >

          {isEditing && (
            <CloseButton updateHandler={() => {
              props.title = undefined;
              editHandler(data.id, props);
            }}
            />
          )}

          <EditableText
            text={props.title.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdate}
          />

        </Grid>
      )}

    </Grid>
  );
}

export default BlockTextWithBackground;
